import { config } from "../../../config/utils";
import { User } from "../interfaces/UserAuthenticated";


/**
 * Devuelve los datos del usuario utilizando la cookie(httpOnly)
 * @cookie Cookie httpOnly seteada con la autenticacion de la api picklog
 * @returns Promise que resuelve un objeto con datos del usuario o null si falla.
 */

export const dataUserAuthenticated = async(): Promise<User | null> => {

    try {
        
        const dataUser = await fetch(`${config.URL_PICKLOG}/sessions/profile`,{
        // const dataUser = await fetch('http://localhost:8080/api/sessions/profile',{
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })

        if(!dataUser.ok) throw new Error(`HTTP error! Status: ${dataUser.status}`)
        const response = await dataUser.json();

        const { user } = response;
        const data = user as User; 

        return data


    } catch (error) {
        return null
    }
}
